import { lazy } from 'react';
import { createRouteItem } from 'utils/navigation';
import type { RouterType } from 'commons/modules/routers/routes';
import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';

const Configuration = lazy(() => import('views/Configuration'));

const routers: RouterType[] = [
  {
    path: '/configuracion',
    component: Configuration,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.configuration,
    exact: true,
    breadcrumbs: {
      title: 'Configuracion',
      routes: [createRouteItem('Home', '/')],
    },
  },
];

export default routers;
